// /**
//  * Parcel - Edit
//  */

// React
import React, { useState, useContext, useEffect } from 'react'
// Context
import AuthContext from '../../../../authContext'

// react hook form
import { useForm, Controller } from 'react-hook-form'

// UI
import theme from '../../../../theme'
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles
} from '@material-ui/core/styles'
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Tooltip,
  FormControlLabel,
  Checkbox
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Modal from '../../../../components/Modal'
import AddItemsParcelsList from './editItemsParcelsList'
import AddItemsParcelsForm from './editItemsParcelsForm'
import AddInventoryItemsParcelsForm from './editInventoryItemsParcelsForm'
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from '@material-ui/pickers'
import jMoment from 'moment-jalaali'
import JalaliUtils from '@date-io/jalaali'

// Client SDK
import Client from 'client-sdk/src/client'
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses'

// Type
import { Parcel, ParcelItems } from '../../interfaces'
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
  PayloadUpdate
} from '../../../parcels/interfaces'
import { Warehouse } from '../../../warehouses/interfaces'
import classes from './edit.module.scss'

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour
} from '../../../../utils/helpers'
import { Product } from '../../../products/interfaces'
import { Variant } from '../../../products/interfaces'
import {
  getParcelsWithIdAction,
  updateParcelsActions,
  deleteParcelItemsActions,
  createParcelItemsActions
} from '../../../parcels/actions'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Store } from '../../../../redux/reducers'
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
  makeSelectParcel
} from '../../../parcels/selectors'

import { useHistory } from 'react-router-dom'
import moment from 'moment'
import ListDimensions from '../../../orderPack/dimensionsList'
import MapPosition from '../../../centers/components/mapPosition'
import windowSize from '../../../../utils/hook/useWindowResize'
import enviroment from 'client-sdk/src/enviroments/enviroment'
import handleNotfication from '../../../../utils/handleNotfication'
import RonadIcons from '../../../../components/iconComponent'
import { isWeekendDay } from '../../../../utils/Date/dayMethods'
import { useCutoffHandler } from '../../../../utils/hook/useGetCutoffListParcel'
import couriersFulfillmentTypes from 'client-sdk/src/parcels/couriersFulfillmentTypes'
import DimensionInputs from './../dimensionInputs'

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })
moment.locale('en')
const date = new Date()
const formattedDateNow = moment(date).format('YYYY-MM-DD')

type Props = {
  create: (body: any) => void
  match: {
    params: {
      id: number
    }
  }
  parcel: Parcel
  onClose: () => void
  warehouseId: number
  updateParcelsDispatch: (payload: PayloadUpdate) => void
  getParcelWithIdActionDispatch: (id: number) => void
  deleteItemDispatch: (payload: Record<string, any>) => void
  createItemDispatch: (payload: Record<string, any>) => void
}

interface SelectorProps {
  parcelsList: Parcel[]
  parcel: Parcel
  count: number
  loading: boolean
  error: any
}

type Inputs = {
  agentName: string
  agentPhoneNumber: string
  deliveryDate: string
  pickAddress: string
  pickDate: string
  pickTime: string
  deliveryTime: string
  destinationId: number
  deliveryType: string
  id: number
  items: ParcelItems[]
  deliveryStartTime: string
  deliveryEndTime: string
  sourceId: number
  status: string
  courierId: number | null
  cutoffId: string | number
  fulfillmentTypeId: null | number
  sourceWarehouseName: string
  destinationWarehouseName: string
  inboundType: string
}

function useOnMount(handler: any) {
  return React.useEffect(handler, [])
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`
  }
}

const inboundItems = [
  {
    name: 'shrink',
    label: 'شیرینک',
    info: 'در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند.',
    code: 'SHIRINK'
  },
  {
    name: 'labelAttachment',
    label: 'برچسب گذاری',
    info: 'لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود.',
    code: 'LABEL_ATTACHMENT'
  },
  {
    name: 'safety',
    label: 'ایمن سازی',
    info: 'در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید.',
    code: 'SAFETY'
  },
  {
    name: 'repackage',
    label: 'تغییر بسته‌بندی',
    info: 'در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود.',
    code: 'RE_PACKAGE'
  },
  {
    name: 'kitting',
    label: 'ترکیب چند قطعه',
    info: 'کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود.',
    code: 'KITTING'
  }
]

const QCItems = [
  {
    name: 'productIdentification',
    label: 'هویت سنجی',
    info: 'با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند',
    code: 'PRODUCT_IDENTIFICATION'
  },
  {
    name: 'checkDate',
    label: 'بررسی تاریخ تولید و انقضا',
    code: 'CHECK_DATE'
  },
  {
    name: 'test',
    label: 'بررسی عملکرد کالا',
    code: 'TEST'
  },
  {
    name: 'checkContents',
    label: 'بررسی محتویات کارتن',
    code: 'CHECK_CONTENTS'
  },
  {
    name: 'requestedQc',
    label: 'کنترل کیفی درخواستی',
    info: 'شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید',
    code: 'REQUESTED_QC'
  }
]

function Edit(props: Props) {
  const features = JSON.parse(localStorage.getItem('profile') || '[]')
  const authContext = useContext(AuthContext)
  const history = useHistory()
  const {
    register,
    handleSubmit,
    errors,
    watch,
    control,
    formState: { isValid },
    setValue,
    getValues,
    reset
  } = useForm<Inputs>({
    defaultValues: {
      deliveryType: '',
      deliveryTime: '',
      inboundType: '',
      deliveryDate: disablePrevDateByHour(14),
      pickDate: disablePrevDateByHour(14),
      pickTime: null,
      cutoffId: null,
      courierId: null,
      fulfillmentTypeId: null,
      deliveryStartTime: null,
      deliveryEndTime: null
      // inboundType: "NORMAL"
    }
  })

  const [deliveryType, setDeliveryType] = useState<any>('')
  const [transportationType, setTransportationType] = useState<any>('')
  const [itemDeleted, setItemDeleted] = useState<any>({})
  const [tab, setTab] = useState(1)
  const [locationModal, setLocationModal] = useState(false)
  const [addressModal, setAddressModal] = useState(false)
  const [itemsInfo, setItemsInfo] = useState<any>([])
  const [openAddItem, setOpenAddItem] = useState(false)
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false)
  const [destinationId, setDestinationId] = useState(
    enviroment.destinationId as number
  )
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  )
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean)
  const [parcelsData, setParcelsData] = React.useState({})
  const [options, setOptions] = React.useState<Warehouse[]>([])
  const [openDimensions, setOpenDimensions] = useState(false as boolean)
  const [openListDimensions, setOpenListDimensions] = useState(false as boolean)
  const [inboundDescription, setInboundDescription] = useState<string>('')
  const [qcDescription, setQcDescription] = useState<string>('')
  const [packageChoice, setPackageChoice] = useState<string[]>([])
  const [dimensions, setDimensions] = useState<any>([])
  const [boxCount, setBoxCount] = useState('')
  const [totalBoxCount, setTotalBoxCount] = useState(0)
  const [count, setCount] = useState('')
  const [length, setLength] = useState('')
  const [width, setWidth] = useState('')
  const [height, setHeight] = useState('')
  const loading = openAutocomplete && options.length === 0
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number
    lng: number
  })

  const [listCourierName, setListCourierName] = useState<any>([])
  const [listFulfillmentTypes, setListFulfillmentTypes] = useState<any>([])
  const [addressDisabled, setAddressDisabled] = useState(false)
  const [dateInDatePiker, setDateInDatePiker] = useState(formattedDateNow)
  const [extraServices, setExtraServices] = useState(false)
  const [isParcelPackageRequired, SetIsParcelPackageRequired] = useState(false)

  const courierId = watch('courierId')
  const cutoffId = watch('cutoffId')
  const deliveryDate = watch('deliveryDate')
  const fulfillmentTypeId = watch('fulfillmentTypeId')
  const values = getValues()

  const typePostingByMyself = listFulfillmentTypes?.length > 0

  const fulfillmentTypeIdIsValid = typePostingByMyself
    ? fulfillmentTypeId
    : null

  const gregorianDate = moment(deliveryDate, 'jYYYY/jMM/jDD').format(
    'YYYY-MM-DD'
  )

  const { listCutoff, handlerHolidays } = useCutoffHandler({
    courierId,
    dateSelected: convertPersianDigit2English(gregorianDate),
    fulfillmentTypeId: fulfillmentTypeIdIsValid,
    entityName: 'parcel',
    setDateInDatePiker,
    setValue,
    editMode: true
  })

  useEffect(() => {
    if (values.inboundType == 'VIP') {
      setPackageChoice([])
    }
  }, [values.inboundType])

  React.useEffect(() => {
    let active = true
    if (!loading) {
      return undefined
    }

    ;(async () => {
      const token = localStorage.getItem('token') || ''
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100
        })
        .build()
      const client = new Client(token)
      const response = await client.execute(makeRequest)
      const warehouses = response.data as any
      if (active) {
        setOptions(warehouses as Warehouse[])
      }
    })()

    return () => {
      active = false
    }
  }, [loading])

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([])
    }
  }, [openAutocomplete])

  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height
    }
    setDimensions([...dimensions, newDimension])
    setCount('')
    setLength('')
    setHeight('')
    setWidth('')
  }

  useEffect(() => {
    if (props?.parcel?.parcelPackages?.length > 0)
      setDimensions(props.parcel.parcelPackages)
  }, [props])

  useEffect(() => {
    let totalCount: any = 0
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count)
    })
    setTotalBoxCount(totalCount)
  }, [dimensions])

  const checkButtonDisabled = () => {
    const fields = [count, length, width, height]
    return fields.some((field) => !field) && totalBoxCount < Number(boxCount)
  }

  const handleCloseDimensions = () => {
    setOpenDimensions(false)
    setBoxCount('')
    setOpenListDimensions(false)
    setDimensions([])
  }

  const setUpdateStatus = () => {
    setCheckSubmit(true)
  }

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO,
      parcelCustomizedOperationDTO,
      deliveryStartTime,
      deliveryEndTime
    const {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      deliveryTime,
      pickAddress,
      pickTime,
      pickDate,
      cutoffId,
      courierId,
      fulfillmentTypeId,
      description,
      inboundType
    } = data

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate: deliveryDate.date
        ? convertPersianDigit2English(deliveryDate.format('YYYY-MM-DD'))
        : deliveryDate,
      pickTime: pickTime?.substring(0, 2).concat(':00:00')
    }

    if (inboundDescription?.length > 500 || qcDescription?.length > 500) {
      // handleNotfication("توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.", "error")
      return
    }

    parcelCustomizedOperationDTO = {
      parcelId: props.parcel.id,
      shrink: packageChoice.indexOf('shrink') !== -1,
      labelAttachment: packageChoice.indexOf('labelAttachment') !== -1,
      safety: packageChoice.indexOf('safety') !== -1,
      repackage: packageChoice.indexOf('repackage') !== -1,
      kitting: packageChoice.indexOf('kitting') !== -1,
      productIdentification:
        packageChoice.indexOf('productIdentification') !== -1,
      checkDate: packageChoice.indexOf('checkDate') !== -1,
      test: packageChoice.indexOf('test') !== -1,
      checkContents: packageChoice.indexOf('checkContents') !== -1,
      requestedQc: packageChoice.indexOf('requestedQc') !== -1,
      inboundDescription,
      qcDescription
    }

    // if (transportationType === 'PARTNER') {
    //   ronadTransportationDTO = {}
    //   deliveryStartTime = convertPersianDigit2English(
    //     deliveryTime.substring(0, 2).concat(':00:00')
    //   )
    //   deliveryEndTime = convertPersianDigit2English(
    //     deliveryTime.substring(3, 5).concat(':00:00')
    //   )
    // } else {
    //   deliveryStartTime = convertPersianDigit2English(
    //     pickTime.substring(0, 2).concat(':00:00')
    //   )
    //   deliveryEndTime = convertPersianDigit2English(
    //     pickTime.substring(3, 5).concat(':00:00')
    //   )
    // }

    addParcel({
      cutoffId,
      courierId,
      fulfillmentTypeId: fulfillmentTypeIdIsValid,
      inboundType,
      parcelPackages: dimensions,
      type: props.parcel.type,
      agentName: agentName ? agentName : null,
      agentPhoneNumber: agentPhoneNumber ? agentPhoneNumber : null,
      deliveryType,
      partnerId: authContext?.user?.partnerId,
      id: props.match.params.id,
      deliveryDate: deliveryDate.date
        ? convertPersianDigit2English(deliveryDate.format('YYYY-MM-DD'))
        : deliveryDate,
      transportationType,
      description,
      ronadTransportationDTO: addressDisabled ? ronadTransportationDTO : null,
      deliveryStartTime,
      deliveryEndTime,
      destinationId,
      origin: props.parcel.origin,
      parcelCustomizedOperationDTO,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD'))
    })
  }

  const addParcel = (body: any) => {
    setParcelsData(body)
    handleOpenCheckConfirm()
  }

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const { id } = props.match.params
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      unitCost
    } = body
    const idItem = product?.id
    const variantId = variant?.id

    props.createItemDispatch({
      body: {
        variantId,
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
        inventoryItems: [
          {
            amount: Number(count),
            unitCost: unitCost ?? 0,
            productionDate: null,
            expirationDate: null
          }
        ]
      },
      id,
      callback: () => {
        props.getParcelWithIdActionDispatch(id)
        setOpenAddItem(false)
      }
    })
  }

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true)
    setItemDeleted(body)
  }

  const handleOpenCheckConfirm = () => {
    setCheckSubmit(true)
  }

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false)
  }

  const handleClose = () => {
    setOpenConfirmDelete(false)
  }

  const deleteItem = () => {
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    )

    setItemsInfo(newValueInfo)
    setOpenAddItem(false)
    handleClose()
  }

  const deleteItemsToParcels = () => {
    props.deleteItemDispatch({
      id: itemDeleted.id,
      callback: () => deleteItem()
    })
  }

  useEffect(() => {
    const { id } = props.match.params
    props.getParcelWithIdActionDispatch(id)
    setOpenAutocomplete(true)
  }, [])

  useEffect(() => {
    if (props.parcel.id) {
      const payload = {
        courierId: props.parcel.courierId,
        cutoffId: props.parcel.cutoffId,
        fulfillmentTypeId: props.parcel.fulfillmentTypeId,
        inboundType: props.parcel.inboundType,
        agentName: props.parcel.agentName,
        agentPhoneNumber: props.parcel.agentPhoneNumber,
        deliveryDate: props.parcel.deliveryDate,
        pickTime: props.parcel.deliveryDate.concat(
          ' ',
          props.parcel.ronadTransportationDTO?.pickTime
        ),
        description: props.parcel.description,
        deliveryStartTime: props.parcel.deliveryDate.concat(
          ' ',
          props.parcel.deliveryStartTime
        ),
        deliveryEndTime: props.parcel.deliveryDate.concat(
          ' ',
          props.parcel.deliveryEndTime
        ),
        deliveryTime:
          props.parcel.deliveryStartTime === '09:00:00'
            ? '09-11'
            : props.parcel.deliveryStartTime === '11:00:00'
            ? '11-13'
            : props.parcel.deliveryStartTime === '14:00:00'
            ? '14-16'
            : ''
      }
      setLatLng({
        lat: props.parcel.ronadTransportationDTO?.lat ?? 0,
        lng: props.parcel.ronadTransportationDTO?.lon ?? 0
      })
      const parcelItems = props.parcel.items.map((item: any) => {
        let variantName = item.productName
        for (let i = 0; i <= 2 && item.featureAndValues[i]; i++) {
          variantName = variantName.concat(
            ' - ',
            item.featureAndValues[i].key,
            ' : ',
            item.featureAndValues[i].value
          )
        }

        if (item.sellerName || item.providerName) {
          const sellerName = item.sellerName ?? item.providerName
          variantName = variantName.concat(' ( ', sellerName, ' )')
        }
        return {
          id: item.id,
          skuId: item.skuId,
          productId: item.skuId,
          count: item.count,
          name: variantName,
          boxCount: item.boxCount,
          countOfBox: item.boxType,
          product: { name: item.productName, code: item.productCode },
          variant: {
            code: item.variantCode,
            features: item.featureAndValues,
            sellerName: item.sellerName,
            providerName: item.providerName
          }
        }
      })
      const newPackageChoice = []
      if (props.parcel?.parcelCustomizedOperationDTO) {
        for (let [key, value] of Object.entries(
          props.parcel.parcelCustomizedOperationDTO
        )) {
          if (value) {
            newPackageChoice.push(key)
          }
        }
      }
      reset(payload)
      setItemsInfo(parcelItems)
      setPackageChoice(newPackageChoice)
      setDeliveryType(props.parcel.deliveryType)
      setTransportationType(props.parcel.transportationType)
      setInboundDescription(
        props.parcel.parcelCustomizedOperationDTO?.inboundDescription
      )
      setQcDescription(props.parcel.parcelCustomizedOperationDTO?.qcDescription)
    }
  }, [props.parcel])

  useEffect(() => {
    setValue('pickAddress', props.parcel.ronadTransportationDTO?.pickAddress)
  }, [addressDisabled])

  useEffect(() => {
    if (props.parcel.id && openAutocomplete && options.length) {
      const currentWarehouse = options.length
        ? options.filter(
            (option) => option.id === props.parcel.destinationId
          )[0]
        : null
      if (!destinationId) {
        setValueWarehouse(currentWarehouse)
        setDestinationId(props.parcel.destinationId)
      }
    }
  }, [props.parcel, openAutocomplete, options])

  useEffect(() => {
    if (destinationId) setOpenAutocomplete(false)
  }, [destinationId])

  const handleCreateParcel = () => {
    const parcelData = { ...parcelsData }
    props.updateParcelsDispatch({
      body: parcelData,
      pagination: {
        page: 0,
        size: 10,
        partnerId: { equals: authContext.user?.partnerId }
      },
      callback: () => {
        setParcelsData({})
        history.push('/parcels-sender')
      }
    })
    handleCloseDimensions()
    setCheckSubmit(false)
  }

  const handleDeliveryDateChange = (date: any) => {
    setValue('deliveryTime', '')
  }

  useOnMount(() => {
    register({ name: 'pickDate', type: 'text', defaultValue: '' })
    register({ name: 'pickTime', type: 'text', defaultValue: '' })
  })

  const handleChange = (event) => {
    const index = packageChoice.indexOf(event.target.name)
    if (index > -1) {
      const newChoises = [...packageChoice]
      newChoises.splice(index, 1)
      setPackageChoice(newChoises)
    } else {
      setPackageChoice([...packageChoice, event.target.name])
    }
  }

  const isFeatureDisable = (code: string) => {
    if (features && features.length > 0) {
      const feature = features.indexOf(code)
      return feature == -1
    }
    return false
  }

  useEffect(() => {
    const handlerFulfillmentTypes = async () => {
      const { res, ok }: any = await couriersFulfillmentTypes('parcel')
      if (ok) {
        setListCourierName(res)
      }
    }
    handlerFulfillmentTypes()
  }, [])

  useEffect(() => {
    if (courierId && listCourierName.length > 0) {
      const res = listCourierName.find(
        (item: any) => item.courierId === courierId
      )
      if (res.fulfillmentTypes?.length === 0) {
        setAddressDisabled(!res.addressDisabled)
        setExtraServices(!res.extraServices)
        SetIsParcelPackageRequired(res.isParcelPackageRequired)
      }
      setListFulfillmentTypes(res.fulfillmentTypes)
    }
  }, [courierId, listCourierName])

  useEffect(() => {
    if (listFulfillmentTypes.length > 0) {
      const res = listFulfillmentTypes.find(
        (item: any) => item.id === fulfillmentTypeId
      )
      setAddressDisabled(!res?.addressDisabled)
      setExtraServices(!res?.extraServices)
      SetIsParcelPackageRequired(res?.isParcelPackageRequired)
    }
  }, [fulfillmentTypeId, listFulfillmentTypes])

  useEffect(() => {
    if (listCutoff.length > 0) {
      const res = listCutoff?.find(
        (item: any) => item?.id === props?.parcel?.cutOffId
      )
      if (res) setValue('cutoffId', res?.id)
    }
  }, [props.parcel, listCutoff])

  useEffect(() => {
    if (courierId && props.parcel.courierId) {
      if (props.parcel.courierId !== courierId) {
        setValue('cutoffId', '')
        setValue('fulfillmentTypeId', null)
      }
    }
  }, [courierId])

  const handlerSubmit = () => {
    if (isValid) {
      setCheckSubmit(true)
    }
  }

  return (
    <>
      <Typography variant='h6' component='h2' style={{ marginBottom: '24px' }}>
        {`ویرایش محموله`}
        <span> &nbsp; {props.match.params.id}</span>
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
        <Typography className={classes.typographyCards}>
          <Button onClick={() => history.goBack()}>
            <RonadIcons name='chevronRight' />
          </Button>
          اطلاعات محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name='courierId'
                    id='courierId'
                    label='* نوع ارسال '
                    data-cy='courierId'
                    render={({ onChange, value }) => (
                      <TextField
                        variant='outlined'
                        select
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        label='* نوع ارسال'
                        onChange={onChange}
                        value={value}
                        error={!!errors.courierId && !!errors.courierId}
                      >
                        {listCourierName.map((item: any) => (
                          <MenuItem
                            key={item.courierId}
                            value={item.courierId}
                            id={item.courierId}
                            disabled={isFeatureDisable('INBOUND_VIP')}
                          >
                            {item.courierName}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.courierId && ' نوع محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>

              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    // rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name='fulfillmentTypeId'
                    label='* نوع ورود'
                    id='fulfillmentTypeId'
                    as={
                      <TextField
                        variant='outlined'
                        select
                        InputLabelProps={{
                          shrink: fulfillmentTypeId !== null
                        }}
                        disabled={!typePostingByMyself}
                        fullWidth
                        error={
                          !!errors.fulfillmentTypeId &&
                          !!errors.fulfillmentTypeId
                        }
                      >
                        {listFulfillmentTypes?.map((item: any) => (
                          <MenuItem
                            value={item.id}
                            id={item.id}
                            // disabled={isFeatureDisable('PICKUP_BY_PARTNER')}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                  />
                </div>
              </Grid>

              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa'>
                    <Controller
                      rules={{ required: true }}
                      name='deliveryDate'
                      control={control}
                      as={
                        <DatePicker
                          inputVariant='outlined'
                          id='deliveryDate'
                          name='deliveryDate'
                          label='* تاریخ تحویل محموله'
                          format='jYYYY/jMM/jDD'
                          minDate={dateInDatePiker}
                          shouldDisableDate={(d: any) =>
                            typeof courierId === 'number'
                              ? handlerHolidays(d?._d)
                              : isWeekendDay(d?._d)
                          }
                          fullWidth
                          disablePast
                          autoOk
                          okLabel={null}
                          cancelLabel={null}
                          // inputRef={register({ required: true })}
                          value={dateInDatePiker}
                          onChange={handleDeliveryDateChange}
                          error={errors.hasOwnProperty('deliveryDate')}
                          helperText={
                            errors.deliveryDate && errors.deliveryDate.message
                          }
                        />
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryDate && 'تاریخ تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    InputLabelProps={{
                      shrink: cutoffId !== ''
                    }}
                    name='cutoffId'
                    id='cutoffId'
                    label={'* بازه تحویل محموله'}
                    as={
                      <TextField
                        variant='outlined'
                        select
                        fullWidth
                        error={!!errors.cutoffId && !!errors.cutoffId}
                      >
                        {listCutoff?.map((item: any) => (
                          <MenuItem
                            disabled={item.disableCutoff}
                            key={item.id}
                            value={item.id}
                            id={item.id}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryTime && ' بازه تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              {addressDisabled && (
                <>
                  <Grid item xs={9} alignItems='flex-end'>
                    <div className={classes.item}>
                      <div style={{ width: '100%' }}>
                        <TextField
                          variant='outlined'
                          fullWidth
                          name='pickAddress'
                          id='pickAddress'
                          label='آدرس جمع آوری'
                          inputRef={register({
                            required: 'آدرس جمع‌آوری الزامی است'
                          })}
                          error={errors.pickAddress && true}
                          helperText={errors.pickAddress?.message}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <Button
                        style={{
                          height: '56px',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                        variant='outlined'
                        size='large'
                        component='span'
                        color='default'
                        onClick={() => setLocationModal(true)}
                      >
                        {latLng.lat == 0 ? (
                          <>
                            <span>اضافه کردن موقعیت مکانی</span>
                            <RonadIcons
                              name='plusCircleOutline'
                              className='text-primary'
                              style={{ marginRight: '5px' }}
                            />
                          </>
                        ) : (
                          <>
                            <span>موقعیت شما با موفقیت ثبت شد</span>
                            <RonadIcons
                              name='checkCircle'
                              size={0.8}
                              className='text-green'
                              style={{ marginRight: '5px' }}
                            />
                          </>
                        )}
                      </Button>
                    </div>
                  </Grid>
                </>
              )}
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <Controller
                      name='agentName'
                      id='agentName'
                      label={
                        transportationType === 'RONAD'
                          ? 'نام مسئول تحویل دهنده'
                          : 'نام مسئول حمل'
                      }
                      control={control}
                      rules={{
                        required: false
                      }}
                      as={
                        <TextField
                          variant='outlined'
                          fullWidth
                          type='text'
                          id='agentName'
                          name='agentName'
                          InputLabelProps={{
                            shrink: !!values.agentName
                          }}
                          // inputRef={register({
                          //   required: false,
                          // })}
                          error={errors.agentName && true}
                        />
                      }
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {errors.agentName?.type === 'required' &&
                    'نام مسئول الزامی می باشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      type='text'
                      id='agentPhoneNumber'
                      name='agentPhoneNumber'
                      label={
                        transportationType === 'RONAD'
                          ? 'شماره مسئول تحویل دهنده(۰۹۱۲۱۲۳۴۵۶۷)'
                          : 'شماره مسئول حمل(۰۹۱۲۱۲۳۴۵۶۷)'
                      }
                      inputRef={register({
                        required: false,
                        minLength: 11,
                        maxLength: 13,
                        pattern: /[0-9]/
                      })}
                      InputLabelProps={{
                        shrink: !!values.agentPhoneNumber
                      }}
                      error={errors.agentPhoneNumber && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {(errors?.agentPhoneNumber?.type === 'minLength' ||
                    errors?.agentPhoneNumber?.type === 'maxLength') &&
                    'شماره همراه ۱۱ تا ۱۳ رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'required' &&
                    'شماره‌ همراه مسئول حمل الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <div className={classes.item}>
                  <Controller
                    name='description'
                    id='description'
                    control={control}
                    rules={{
                      required: false,
                      maxLength: 500
                    }}
                    render={({ onChange, value }) => (
                      <TextField
                        variant='outlined'
                        fullWidth
                        value={value}
                        // inputRef={register({ required: false })}
                        name='description'
                        InputLabelProps={{
                          shrink: !!value
                        }}
                        onChange={onChange}
                        label='توضیحات'
                        data-cy='warehouseAddress'
                      />
                    )}
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.description?.type === 'maxLength' &&
                    'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                </FormHelperText>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{ marginTop: '8px' }}>
                  <RonadIcons
                    name='information'
                    size={0.7}
                    style={{ color: '#43778E' }}
                  />
                  <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                    در اینباند ویژه کالاهای موجود در محموله حداکثر تا 3 ساعت
                    کاری جای‌گذاری شده و با تعرفه ویژه محاسبه می‌شوند.
                  </Typography>
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{ marginTop: '4px' }}>
                  <RonadIcons
                    name='information'
                    size={0.7}
                    style={{ color: '#43778E' }}
                  />
                  <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                    آدرس انبار: تهران، محله شادآباد، خیابان ١٧ شهریور، بین شهدای
                    اسلامی و بسیج مستضعفین، پلاک 344 کدپستی: 1378795599{' '}
                    <span
                      onClick={() => setAddressModal(true)}
                      className='link'
                    >
                      نمایش لوکیشن
                    </span>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Typography className={classes.typographyCards}>خدمات مازاد</Typography>
        <Card className={classes.card}>
          <CardContent style={{ margin: '14px 0  0', padding: '0 0 12px 0' }}>
            <ul className={classes.tabContainer}>
              <li
                onClick={() => setTab(1)}
                className={
                  classes.tabItems + ' ' + (tab == 1 && classes.active)
                }
              >
                اینباند
              </li>
              <li
                onClick={() => setTab(2)}
                className={
                  classes.tabItems + ' ' + (tab == 2 && classes.active)
                }
              >
                کنترل کیفی
              </li>
            </ul>
            {tab == 1 && (
              <Grid
                container
                justifyContent='space-between'
                style={{ marginTop: '24px' }}
              >
                {inboundItems.map((item) => (
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChange}
                          checked={packageChoice.includes(item.name)}
                          name={item.name}
                          color='primary'
                          disabled={extraServices}
                          size='small'
                        />
                      }
                      label={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px'
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color: extraServices
                                ? '#bdbdbd'
                                : 'rgba(47, 72, 88, 1)'
                            }}
                          >
                            {item.label}
                          </Typography>
                          <RonadIcons
                            name='information'
                            size={0.6}
                            title={item.info}
                            className={classes.icon + ' text-primary'}
                          />
                        </div>
                      }
                    />
                  </Grid>
                ))}
                <Grid style={{ marginTop: '30px' }} item xs={12}>
                  <div className={classes.item}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      // inputRef={register({ required: false })}
                      value={inboundDescription}
                      name='inboundDescription'
                      placeholder='لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید.'
                      label='توضیحات'
                      InputLabelProps={{
                        shrink: true
                      }}
                      data-cy='warehouseAddress'
                      onChange={(e) => setInboundDescription(e.target.value)}
                    />
                  </div>
                  <FormHelperText error focused>
                    {inboundDescription?.length > 500 &&
                      'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                  </FormHelperText>
                </Grid>
              </Grid>
            )}
            {tab == 2 && (
              <Grid
                container
                justifyContent='space-between'
                style={{ marginTop: '24px' }}
              >
                {QCItems.map((item) => (
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleChange}
                          checked={packageChoice.includes(item.name)}
                          name={item.name}
                          disabled={extraServices}
                          color='primary'
                          size='small'
                        />
                      }
                      label={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px'
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color: extraServices
                                ? '#bdbdbd'
                                : 'rgba(47, 72, 88, 1)'
                            }}
                          >
                            {item.label}
                          </Typography>
                          {item.info && (
                            <RonadIcons
                              name='information'
                              size={0.6}
                              title={item.info}
                              className={classes.icon + ' text-primary'}
                            />
                          )}
                        </div>
                      }
                    />
                  </Grid>
                ))}
                <Grid style={{ marginTop: '30px' }} item xs={12}>
                  <div className={classes.item}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      // inputRef={register({ required: false })}
                      value={qcDescription}
                      name='qcDescription'
                      placeholder='لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید.'
                      label='توضیحات'
                      InputLabelProps={{
                        shrink: true
                      }}
                      data-cy='warehouseAddress'
                      onChange={(e) => setQcDescription(e.target.value)}
                    />
                  </div>
                  <FormHelperText error focused>
                    {qcDescription?.length > 500 &&
                      'توضیحات باید حداکثر ۵۰۰ کاراکتر باشد.'}
                  </FormHelperText>
                </Grid>
              </Grid>
            )}
            <Grid container className='notif'>
              <RonadIcons
                name='information'
                size={0.7}
                style={{ color: '#43778E' }}
              />
              <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                درخواست‌های مورد نظر بر روی تمامی کالاهای محموله اعمال می گردد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        {['65', '2', '119'].includes(authContext?.user?.partnerId) && (
          <>
            <Typography className={classes.typographyCards}>
              اطلاعات انبار مقصد
            </Typography>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <Autocomplete
                        style={{ width: '100%' }}
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete(true)
                        }}
                        onClose={() => {
                          setOpenAutocomplete(false)
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value.name
                        }
                        getOptionLabel={(option) => option.name}
                        options={options}
                        loading={loading}
                        onChange={(event: any, newValue: any | null) => {
                          setDestinationId(newValue?.id)
                          setValueWarehouse(newValue)
                        }}
                        renderInput={(params) => (
                          <TextField
                            variant='outlined'
                            {...params}
                            label='انبار مقصد'
                            inputRef={register({ required: false })}
                            name='admin'
                            id='admin'
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      color='inherit'
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              )
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={9} sm={9} lg={9} spacing={2}>
                    <div className={classes.item}>
                      <TextField
                        variant='outlined'
                        fullWidth
                        // defaultValue={' '}
                        value={valueWarehouse ? valueWarehouse?.address : ''}
                        label='آدرس انبار'
                        inputProps={{ readOnly: true }}
                        data-cy='warehouseAddress'
                      />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        )}
        <Typography className={classes.typographyCards}>
          کالاهای محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent
            style={{ margin: '14px 0  0', padding: '0 16px 24px 16px' }}
          >
            <Grid container justifyContent='flex-end'>
              <Button
                // style={{ marginBottom: '24px' }}
                variant='outlined'
                color='primary'
                size='large'
                startIcon={
                  <RonadIcons
                    name='plusCircleOutline'
                    className='text-primary'
                  />
                }
                onClick={() => {
                  setOpenAddItem(true)
                }}
                data-cy='addProduct'
              >
                {'افزودن کالا به محموله'}
              </Button>
            </Grid>
            <Grid container>
              {itemsInfo.length > 0 && (
                <AddItemsParcelsList
                  data={itemsInfo}
                  deleteItem={(body: any) => setConfirmDelete(body)}
                />
              )}
            </Grid>
          </CardContent>
        </Card>

        <Typography className={classes.typographyCards}>
          بسته های محموله
        </Typography>

        <DimensionInputs
          isParcelPackageRequired={isParcelPackageRequired}
          setDimensions={setDimensions}
          dimensions={dimensions}
        />

        <Grid container justifyContent='flex-end'>
          {/* <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
            >
              {'انصراف'}
            </Button> */}

          <Button
            type='submit'
            size='medium'
            id='saveParcel'
            variant='contained'
            color='primary'
            onClick={handlerSubmit}
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                .length === 0
            }
          >
            {'ذخیره محموله '}
          </Button>
        </Grid>
      </form>
      <Dialog open={props.loading} aria-labelledby='responsive-dialog-title'>
        <DialogContent>
          <Typography variant='h4' style={{ padding: '100px' }}>
            در حال ذخیره محموله
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openConfirmDelete}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            {handleClose ? (
              <IconButton aria-label='close' onClick={handleClose}>
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleClose}
                variant='outlined'
                color='primary'
                size='large'
              >
                {'انصراف'}
              </Button>
              <Button
                variant='contained'
                onClick={deleteItemsToParcels}
                size='large'
                color='primary'
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            {handleClose && (
              <IconButton aria-label='close' onClick={handleClose}>
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            )}
          </div>

          <div className={classes.cancelTitle}>
            {`آیا از ویرایش محموله مطمئن هستید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ marginLeft: '8px' }}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant='outlined'
                color='primary'
                size='large'
              >
                {'انصراف'}
              </Button>
              <Button
                id='confirmEditParcel'
                color='primary'
                variant='contained'
                onClick={handleCreateParcel}
                size='large'
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth='md'
        open={locationModal}
        onClose={() => setLocationModal(false)}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            <IconButton
              aria-label='close'
              onClick={() => setLocationModal(false)}
            >
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6892, lng: 51.389 }}
            position={latLng}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng)
            }}
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setLocationModal(false)}
                variant='contained'
                color='primary'
                size='large'
                data-cy='cancelCreateParcel'
              >
                {'تایید'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth='md'
        open={addressModal}
        onClose={() => setAddressModal(false)}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            <IconButton
              aria-label='close'
              onClick={() => setAddressModal(false)}
            >
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6700926, lng: 51.2933106 }}
            position={{ lat: 35.6700926, lng: 51.2933106 }}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              // setLatLng(latLng);
            }}
            readOnly
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setAddressModal(false)}
                variant='contained'
                color='primary'
                size='large'
                data-cy='cancelCreateParcel'
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label='close'
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <RonadIcons name='cubeOutline' size={4} />
          </div>
          {boxCount && openListDimensions ? (
            <Grid container alignItems='center' spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems='flex-end'
              >
                <Grid item xs={2}>
                  <RonadIcons name='counter' size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id='count'
                    name='count'
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                    label='تعداد'
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems='flex-end'
              >
                <Grid item xs={2}>
                  <RonadIcons name='rowHeight' size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id='length'
                    name='length'
                    value={length}
                    onChange={(e) => setLength(e.target.value)}
                    label='طول'
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems='flex-end'
              >
                <Grid item xs={2}>
                  <RonadIcons name='columnWidth' size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id='width'
                    name='width'
                    value={width}
                    onChange={(e) => setWidth(e.target.value)}
                    label='عرض'
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems='flex-end'
              >
                <Grid item xs={2}>
                  <RonadIcons name='ruller' size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id='height'
                    name='height'
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    label='ارتفاع'
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems='flex-end'>
              <Grid item xs={12}>
                <p>{'تعداد بسته‌بندی های محموله را وارد کنید'}</p>
              </Grid>
              <Grid item xs={1}>
                <RonadIcons name='counter' size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id='boxCount'
                  name='boxCount'
                  value={boxCount}
                  onChange={(e) => setBoxCount(e.target.value)}
                  label='تعداد بسته'
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant='contained'
                  color='secondary'
                  disabled={checkButtonDisabled()}
                  size='large'
                >
                  {totalBoxCount >= Number(boxCount)
                    ? 'مرحله بعد'
                    : 'اضافه کردن بسته'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant='contained'
                  onClick={() => handleClose()}
                  size='large'
                >
                  {'بازگشت'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant='contained'
                  color='secondary'
                  disabled={!boxCount}
                  size='large'
                >
                  {'مرحله بعد'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant='contained'
                  onClick={() => handleCloseDimensions()}
                  size='large'
                >
                  {'بستن'}
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth='sm'
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant='h6'
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />
    </>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcel: makeSelectParcel(),
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    updateParcelsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateParcelsActions(payload)),
    deleteItemDispatch: (payload: Record<string, any>) =>
      dispatch(deleteParcelItemsActions(payload)),
    createItemDispatch: (payload: Record<string, any>) =>
      dispatch(createParcelItemsActions(payload))
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(Edit)
